import { useEffect, useState } from "react";
import { useTranslation, withTranslation } from "react-i18next";
import { ToggleSlider, useToggleSlider } from "react-toggle-slider";
import images from "ressources/images";
import { active } from "timers-browserify";
import FiltersDataContent from "../FiltersDataContent/FiltersDataContent";

import "./FiltersMenuItem.scss";

const DropDownButton = ({ label, open, disabled, onClick }) => {
  return (
    <button
      disabled={disabled}
      onClick={onClick}
      className={`item_row item_content ${disabled && `item_disabled`}`}
    >
      <div>{label}</div>
      <div>
        <img
          alt="chevron"
          className={open ? "rotate-180" : ""}
          src={images.chevron_down}
        ></img>
      </div>
    </button>
  );
};

// Simple component used as in the SearchFiltersMenu
// to display content needed to filter before searching
const FiltersMenuItem = ({
  src,
  headerLabel,
  contentLabel,
  data,
  setfilters,
  filters,
  filter,
  name,
  id,
  enableTarget,
}) => {
  const [open, setopen] = useState(false);

  // Disable item row and close the content menu
  const onChange = (e) => {
    setfilters({
      ...filters,
      [enableTarget]: !filters[enableTarget],
      [filter]: [],
    });
    setopen(false);
  };

  // Unroll content menu
  const onClick = (e) => {
    e.preventDefault();
    setopen(!open);
  };

  const checked = filters[enableTarget];

  return (
    <>
      <div className="item_row item_header">
        <div
          style={{
            display: "flex",
            justifyContent: "flex-start",
            alignItems: "center",
            gap: "10px",
          }}
        >
          <img style={{ width: "30px", height: "30px" }} src={src} alt="logo" />
          <div style={{ display: "flex", alignItems: "center" }}>
            {headerLabel}
          </div>
        </div>
        <div className="vertical_center">
          <label className="switch" htmlFor={`${enableTarget}-checkbox`}>
            <input
              type="checkbox"
              id={`${enableTarget}-checkbox`}
              checked={checked}
              onChange={onChange}
            />
            <div className="slider round"></div>
          </label>
        </div>
      </div>
      <DropDownButton
        disabled={!checked}
        onClick={onClick}
        label={contentLabel}
        open={open}
      />
      {open && data && (
        <FiltersDataContent
          data={data}
          filters={filters}
          setfilters={setfilters}
          filter={filter}
          name={name}
          id={id}
        />
      )}
    </>
  );
};

export { DropDownButton };

export default FiltersMenuItem;
